// Imports
import React, {Component, useEffect, useState} from 'react';

// Import Search Bar Components
//import SearchBar from 'material-ui-search-bar';
// Import React Scrit Libraray to load Google object
import Script from 'react-load-script';
import {TextField} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Config from "../constants/Config";
import axios from "axios";
import {getAreaDetails} from "../services/actions";


// const SearchF = (props) => {
//  const [query,setQuery] = useState('') ;
//  const [ city,setCity] = useState('');
//  const [selectedLocation,setSelectedLocation] = useState('')
//  const [predictions,setPredictions] = useState([])
//
//
//     const language = props.countryAlpha2 === 'IL'? "he": "en"
//
//
//     useEffect(()=>{
//         const areaName = props.serviceAreaName
//         if (areaName) {
//             getAreaDetails(areaName)
//                 .then(data => {
//                     if (data !== undefined) {
//                         const areaName = data.AreaName;
//                         const areaDetails = JSON.parse(data.AreaDetails);
//                         props.updateForm(props.formID, {
//                             description: areaName,
//                             long: areaDetails['location']['lng'],
//                             lat: areaDetails['location']['lat'],
//                         });
//                         setQuery(areaName);
//                     }
//                 })
//         }
//     },[])
//
//
//     useEffect(() => {
//         handleSelect()
//     },[selectedLocation])
//
//     useEffect(() => {
//         fetchResults()
//     },[query])
//
//
//     const fetchResults = async (useCountry = true) => {
//         const countryCode = props.countryAlpha2 ;
//       await  fetch(
//             `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${query}${
//                 useCountry
//                     ? `&components=country:${countryCode}${
//                         countryCode === 'IL' ? '|country:PS' : ''
//                     }`
//                     : ''
//             }&types=locality|route&language=${language}&key=AIzaSyDFbswAUbdZbQFeEy-s2oHc-_-dIcCAZPo`,
//         )
//             .then(response=>response.json())
//             .then(data=>{
//                 if (data && data.predictions) {
//                     data.predictions = data.predictions.filter(
//                         item =>
//                             item.description !== 'London, UK' &&
//                             item.description !== 'ישראל' &&
//                             item.description !== 'פלסטין' &&
//                             item.description !== 'Palestine' &&
//                             item.description !== 'Israel',
//                     );
//
//                     // data.predictions = data.predictions.filter(item => {
//                     //     return !item.types.includes('political');
//                     // });
//                     setPredictions(data.predictions)
//                 }})
//
//     }
//
//     const handleSelect = async () => {
//
//      setQuery('')
//         // Check if address is valid
//         if (selectedLocation) {
//             // Set State
//
//             let {data} = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?place_id=${selectedLocation.place_id}&key=AIzaSyDFbswAUbdZbQFeEy-s2oHc-_-dIcCAZPo`)
//
//             setCity(selectedLocation.structured_formatting.main_text);
//             setQuery(selectedLocation.description);
//
//             props.updateForm(props.formID, {
//                 description: selectedLocation.description,
//                 long:data.results[0].geometry.location.lng,
//                 lat: data.results[0].geometry.location.lat,
//             })
//         }
//
//     }
//
//
//
//     return (
//         <div style={{width:'100%'}}>
//             <Autocomplete
//                 onInput={(e) => {
//                     console.log("e.target.value",e.target.value)
//                     setQuery(e.target.value)
//                     // await fetchResults(e.target.value)
//                 }}
//                 options={predictions}
//                 filterOptions={(x) => x}
//                 getOptionLabel={item => item.description}
//                 onChange={(e,value) => {
//                     setSelectedLocation(value);
//                 }
//                 }
//                 renderInput={params => {
//                     console.log('we got rendered')
//                 return <>
//                     <TextField
//                         {...params}
//                         label={props.label}
//                         fullWidth
//                         variant="outlined"
//                     />
//                 </>
//             }}
//
//             />
//
//         </div>
//     )
// }




class Search extends Component {
    // Define Constructor
    constructor(props) {
        super(props);

        // Declare State
        this.state = {
            city: '',
            query: ''
        };
    }

    componentDidMount() {
        const areaName = this.props.serviceAreaName

        if (areaName) {
            getAreaDetails(areaName)
            .then(data => {
                if (data !== undefined) {
                    const areaName = data.AreaName;
                    const areaDetails = JSON.parse(data.AreaDetails);
                    this.props.updateForm(this.props.formID, {
                        description: areaName,
                        long: areaDetails['location']['lng'],
                        lat: areaDetails['location']['lat'],
                    });
                    this.setState({ query: areaName });
                }
            })
        }
    }

    handleScriptLoad = () => {
        const countryRestrictions = this.props.countryAlpha2 === 'GB' ? ['GB', 'IE'] : this.props.countryAlpha2;

        // Declare Options For Autocomplete
        const options = {
            types: this.props.countryAlpha2 === 'IL' ? ['locality','route'] : ['address'],
            componentRestrictions: { country: countryRestrictions },
        };

        // Initialize Google Autocomplete
        /*global google*/ // To disable any eslint 'google not defined' errors
        this.autocomplete = new google.maps.places.Autocomplete(
            document.getElementById('autocomplete'),
            options,
        );
        this.autocomplete.setComponentRestrictions(
            {'country': ['uk']}
        );

        // Avoid paying for data that you don't need by restricting the set of
        // place fields that are returned to just the address components and formatted
        // address.
        this.autocomplete.setFields(['address_components', 'formatted_address', "geometry"]);
        // Fire Event when a suggested name is selected
        this.autocomplete.addListener('place_changed', this.handlePlaceSelect);
    }

    handlePlaceSelect = () => {
        this.setState({ query: '' });
        // Extract City From Address Object
        const addressObject = this.autocomplete.getPlace();
        const address = addressObject.address_components;

        // Check if address is valid
        if (address) {
            // Set State
            this.setState(
                {
                    city: address[0].long_name,
                    query: addressObject.formatted_address,
                }
            );
            this.props.updateForm(this.props.formID, {
                description: addressObject.formatted_address,
                long: addressObject.geometry.location.lng(),
                lat: addressObject.geometry.location.lat(),
            })
        }
    }

    render() {
        let {loading} = this.state;
        const language = this.props.countryAlpha2 === 'IL'? "iw": "en"
        return (
            <div style={{width: "100%"}}>
                <Script
                    url={`https://maps.googleapis.com/maps/api/js?region=${this.props.countryAlpha2}&key=${Config.googleApiKey}&libraries=places&language=${language}&strictbounds`}
                    onLoad={this.handleScriptLoad}
                />
                <Autocomplete
                    id="autocomplete"
                    popupIcon={""}
                    value={this.state.query ? this.state.query : null}
                    onChange={() => {this.setState({query: ""}); this.props.updateForm(this.props.formID, "")}}
                    clearOnBlur={true}
                    open={false}
                    options={[]}
                    renderInput={params => (
                        <div className={""}>
                            <TextField
                                {...params}
                                id="filled-required"
                                label={this.props.label}
                                fullWidth
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        </div>
                    )}
                />
            </div>
        );
    }
}

export default Search;
